<script>
export default {
  name: 'IconMessageSquare',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#231F20',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7935 1.33301H5.20683C2.78016 1.33301 1.3335 2.77967 1.3335 5.20634V10.7863C1.3335 13.2197 2.78016 14.6663 5.20683 14.6663H10.7868C13.2135 14.6663 14.6602 13.2197 14.6602 10.793V5.20634C14.6668 2.77967 13.2202 1.33301 10.7935 1.33301ZM12.1868 8.60634C12.1868 8.73967 12.1802 8.87301 12.1668 8.99967C12.0468 10.413 11.2135 11.1197 9.68016 11.1197H9.46683C9.3335 11.1197 9.20683 11.1797 9.1335 11.2863L8.50683 12.1263C8.22683 12.4997 7.78016 12.4997 7.50016 12.1263L6.8735 11.2863C6.80683 11.1997 6.6535 11.1197 6.54016 11.1197H6.32683C4.6535 11.1197 3.82016 10.7063 3.82016 8.61301V6.50634C3.82016 4.97301 4.52683 4.13967 5.94016 4.01967C6.0535 4.00634 6.18683 3.99967 6.32683 3.99967H9.68016C11.3535 3.99967 12.1868 4.83967 12.1868 6.50634V8.60634Z"
      :fill="color"
    />
  </svg>
</template>
